import { useCallback } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { liveStatus, liveStatusLabel, liveStartDate } from "@/lib/metaUtil";
import { ButtonLink, FavoriteButton } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import routes from "@/lib/routes";
import IconCatchup from "../../../svgs/icon_catchup.svg";
import VersatileLink from "@/components/VersatileLink";

export default function LivePickupListRow({ item }) {
  const handleClick = useCallback(
    (e) => {
      if (!item.isAllowedRating) {
        e.preventDefault();
      }
    },
    [item]
  );

  return (
    <div
      className={classnames(styles.container, styles.pickup, {
        [styles.notAllowed]: !item.isAllowedRating,
      })}
    >
      <div className={styles.inner}>
        <div className={styles.artwork}>
          <CardArtwork
            item={item}
            className={styles.artworkInner}
            href={routes.watch(item.id)}
            linkAttr={{ onClick: handleClick }}
          />
        </div>
        <div className={styles.info}>
          <h4 className={styles.title}>
            <VersatileLink onClick={handleClick} href={routes.watch(item.id)}>
              {item.name}
            </VersatileLink>
          </h4>
          <div className={styles.liveStatus}>
            <span className={classnames({ [styles.onair]: liveStatus(item) })}>
              {liveStatusLabel(item)}
            </span>{" "}
            {item.delivery_start_at && <span>{liveStartDate(item)}</span>}
            {item.catch_up_flag && (
              <span className={styles.catchupIcon}>
                <IconCatchup />
              </span>
            )}
            <div className={styles.tags}>
              <span>{item.genres.map((genre) => genre.name).join("/")}</span>
            </div>
          </div>
          <p className={styles.description}>{item.description}</p>
          <div className={styles.buttons}>
            <ButtonLink
              fillColor
              medium
              href={routes.watch(item.id)}
              disabled={!item.isAllowedRating}
            >
              視聴する
            </ButtonLink>
            <FavoriteButton
              transparent
              borderGray
              favBtnWithLabel
              metaId={item.id}
              text="お気に入り"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
